import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import {Observable} from "rxjs";
import {GetCustomersCB} from "../../Ope/Customer/GetCustomersCB";
import {GetAllCustomersCB} from "../../Ope/Customer/GetAllCustomersCB";
import {PutCustomerCB} from "../../Ope/Customer/PutCustomerCB";
import {DelCustomerCB} from "../../Ope/Customer/DelCustomerCB";
import {ChangeCustomerOwnerCB} from "../../Ope/Customer/ChangeCustomerOwnerCB";

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends BaseService {

  public getCustomers(cb: GetCustomersCB): Observable<any> {
    return this.execOPE(cb);
  }

  public getAllCustomers(cb: GetAllCustomersCB): Observable<any> {
    return this.execOPE(cb);
  }

  public putCustomer(cb: PutCustomerCB): Observable<any> {
    return this.execOPE(cb);
  }

  public changeCustomerOwner(cb: ChangeCustomerOwnerCB): Observable<any>
  {
    return this.execOPE(cb);
  }

  public delCustomer(cb: DelCustomerCB): Observable<any> {
    return this.execOPE(cb);
  }


}
